/*@ngInject*/
const RepeatingRowController = function ($rootScope, $scope, $element, fieldType, formViewerConstant) {

        this.$onInit = function () {
            $element.addClass('formRow');
            $element.addClass('repeatingFormRow');
        };

        this.onSelectRow = function(event){
            $rootScope.$broadcast(formViewerConstant.event.REPEATING_ROW_SELECTED, event, this.row);
        };
    };

angular.module('umFormViewer')
    .controller('repeatingRowController', RepeatingRowController);
